import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=3cceb4fa&scoped=true&"
var script = {}
import style0 from "./Services.vue?vue&type=style&index=0&id=3cceb4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cceb4fa",
  null
  
)

export default component.exports